import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { ClientPreview } from '~/components/ClientPreview/ClientPreview';
import { useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
export const usePreviewDraft = (param)=>{
    let { sampleContact, contactsMap } = param;
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const worksAt = useStore(selectors.user.business);
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const previewDraft = async (draftId)=>{
        if (!worksAt) return;
        const result = await handleRequest(api.draft.getById(draftId));
        if (!result.success) {
            overlayContext.showErrorToast(errorTexts.unexpected(), 'preview-draft-error');
            return;
        }
        const dto = result.data.toDTO();
        overlayContext.showModal({
            biName: 'client_preview_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (props)=>/*#__PURE__*/ _jsx(ClientPreview, _object_spread({
                    type: "draft",
                    draftInfo: {
                        draft: dto,
                        sampleContact,
                        contactsMap
                    },
                    entityContext: {
                        source: 'draft',
                        id: draftId
                    }
                }, props))
        });
    };
    return {
        previewDraft
    };
};
